export default __webpack_public_path__ + "static/media/image.xeptagon-private-limited.88fe8b00.png";